import React, { useEffect, useRef, useState } from "react";
import { FormGroup, Input } from "@cofano/cck";
import "swagger-ui-react/swagger-ui.css";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { CircularProgress } from "@mui/material";
const SwaggerUI = React.lazy(() => import("swagger-ui-react"));
const Documentation = () => {
	const { instance } = useCoastguard();
	const [ spec, setSpec ] = useState("");

	useEffect(() => {
		const fetchData = async () => {
			const response = await instance.fetch("/cofano/openapi.json", {});
			let text = JSON.stringify(await response.json());
			text = text.replaceAll("\"example\":null,", "");
			text = text.replaceAll("\"example\":null", "");
			setSpec(text);
		};
		fetchData();
	}, []);

	const username = instance.getUserDetails!.username;
	const [ token, setToken ] = useState("");
	const tokenRef = useRef<string>("");

	useEffect(() => {
		tokenRef.current = token;
	}, [ token ]);

	//eslint-disable-next-line @typescript-eslint/no-explicit-any
	const interceptor = (req: any) => {
		req.headers["Authorization"] = "Basic " + btoa(username + ":" + tokenRef.current);
		return req;
	};

	return <>
		<FormGroup label="API password" overflow="hidden" required>
			<Input type='password' value={token} onChange={event => setToken(event.target.value)} />
		</FormGroup>
		{!spec ? <CircularProgress size={24} /> :
			<SwaggerUI spec={spec} deepLinking={true} requestInterceptor={interceptor} />}
	</>;
};

export default Documentation;
